import lodash from 'lodash'

const { round } = lodash

export const calcVat = (amount: number, percantage: number) => {
  return round((percantage / 100) * amount, 2)
}
